<div class="card card-shadow">
    <div class="card-body">
        <div class="border-bottom mb-3">
            <div class="font-weight-normal">
                <h6 class="">WELCOME TO</h6>
                <h5 class="text-default fw-bold">Navodaya Vidyalaya Samiti</h5>
            </div>
        </div>
        <ul class="list-unstyled">
            <li class="d-flex justify-content-start mb-4">
                <p class="description mt-0">Navodaya Vidyalaya Samiti, is working under the MHRD, Government
                    Of India, It was formed to provide good quality modern education-including a strong component of
                    culture,
                    inculcation of values, awareness of the environment, adventure activities and physical
                    education- to the talented children predominantly from the rural areas without regard to their
                    family's socio-economic conditions.</p>
            </li>
        </ul>
        <div class="d-flex justify-content-end">
            <a href="https://navodaya.gov.in/" target="_blank" class="btn btn-primary btn-sm">Read More</a>
        </div>
    </div>
</div>